import script from "./px-checkbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./px-checkbox.vue?vue&type=script&lang=ts&setup=true"

import "./px-checkbox.vue?vue&type=style&index=0&id=61e35f48&lang=scss"

const __exports__ = script;

export default __exports__